export default "__VITE_ASSET__Bj0CzccO__"